export default "__VITE_ASSET__rRoSi_uw__"